import { createReducer } from '../../utils';
import * as Types from './types';
import { isServiceError } from '../../utils/errorCodes';

const initialState = {
  formValues: {
    CFT2: '',
    CFT3: '',
    CFT4: '',
    CFT7: '',
    CFT100: '',
    CFT101: '',
    CFT5: ''
  },
  unitMeasurement: {
    total: '1',
    covered: '1'
  },
  antiquityType: null,
  loading: true,
  fetchCompleted: false,
  fetchError: false,
  //con este valor identifico si ya guardo algun valor para no colocar valores por defecto
  hasSavedData: true
};

const antiquityOptionsValues = {
  EN_CONSTRUCCION: '1',
  A_ESTRENAR: '2',
  USADO: '3'
};

const featuresReducer = createReducer(initialState)({
  [Types.GET_FORM_VALUES]: state => ({ ...state, loading: true, fetchError: false, fetchCompleted: false }),
  [`${Types.GET_FORM_VALUES}_FAILED`]: (state, action) => ({
    ...state,
    ...action.payload,
    loading: false,
    fetchError: isServiceError(action?.payload?.status)
  }),
  [`${Types.GET_FORM_VALUES}_COMPLETED`]: (state, action) => {
    const savedFormValues = {};
    const savedUnitMeasurement = {};
    let antiquityType = null;

    // eslint-disable-next-line no-unused-expressions
    action.payload?.features?.forEach(el => {
      savedFormValues[el.feature_id] = el.value ? Number(el.value) : '';
      if (el.feature_id === 'CFT6') {
        savedFormValues[el.feature_id] = el.value ? Number.parseInt(el.value) : el.value;
      }
      if (el.feature_id === 'CFT100') {
        savedFormValues[el.feature_id] = el.value ? Number(el.value) : '';
        savedUnitMeasurement.total = el.value_unit || '1';
      }
      if (el.feature_id === 'CFT101') {
        savedFormValues[el.feature_id] = el.value ? Number(el.value) : '';
        savedUnitMeasurement.covered = el.value_unit || '1';
      }
      if (el.feature_id === 'CFT5') {
        if (el.value === '-1') return (antiquityType = antiquityOptionsValues.EN_CONSTRUCCION);
        if (el.value === '0') return (antiquityType = antiquityOptionsValues.A_ESTRENAR);
        if (el.value && el.value !== '') return (antiquityType = antiquityOptionsValues.USADO);
      }
    });

    return {
      ...state,
      loading: false,
      fetchCompleted: true,
      // Reviso que al menos 1 dato del form tenga guardado valor para determinar que tiene datos guardados
      hasSavedData: action.payload.features?.some(f => {
        // hago una revision manual de antiguedad por que puede tener valor 0 y es valido
        const antiquityWithSavedValue = f.feature_id === 'CFT5' && (f.value !== '' && f.value !== null);
        return antiquityWithSavedValue || Number(f.value) > 0;
      }),
      formValues: {
        ...state.formValues,
        ...savedFormValues
      },
      unitMeasurement: {
        ...state.unitMeasurement,
        ...savedUnitMeasurement
      },
      antiquityType
    };
  },
  // el valor que tiene que llegar aca es un objeto, Ej: -> { CFT100: 1, CFT101: -1 }
  [Types.UDPATE_FORMVALUES]: (state, action) => {
    const tempObj = {};
    const keys = Object.keys(action.payload);
    keys.forEach(k => {
      tempObj[k] = action.payload[k];
    });
    return { ...state, formValues: { ...state.formValues, ...tempObj } };
  },
  [Types.UPDATE_UNIT_MEASUREMENT]: (state, action) => ({
    ...state,
    unitMeasurement: {
      ...state.unitMeasurement,
      [action.payload.unitToUpdate]: action.payload.value
    }
  }),
  [Types.SET_ANTIQUITY_TYPE]: (state, action) => ({
    ...state,
    antiquityType: action.payload
  }),
  [Types.RESET_INFO]: () => initialState
});

export { featuresReducer };
